// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4z-6";
export var headerCell = "_4z-2";
export var rowWrapper = "_4z-4";
export var stickyAggregationCell = "_4z-a";
export var stickyAggregationRow = "_4z-7";
export var stickyColumnCell = "_4z-9";
export var stickyColumnHeaderCell = "_4z-8";
export var table = "_4z-1";
export var virtualRowWrapper = "_4z-5";
export var virtualTableContainer = "_4z-0";
export var white = "_4z-3";